import './invoice_templates/invoice_templates-module';
import './position_categories/position_categories-module';
import './positions/positions-module';
import './position_links/position_links-module';
import './invoices/invoices-module';
import './number-circles/number-circle-module';

/**
 * @ngdoc object
 * @name billing
 * @description
 *
 */
angular
    .module('festzelt-os.billing', [
        'ui.router',
        'festzelt-os.components',
        'festzelt-os.billing.invoice_templates',
        'festzelt-os.billing.position_categories',
        'festzelt-os.billing.positions',
        'festzelt-os.billing.invoices',
        'festzelt-os.billing.position_links',
        'festzelt-os.billing.number-circles'
        //'ngListView'
    ]).run([
    'locale',
    (locale) => {
        locale.ready('billing');
    }
]);


require('./billing-routes');



// WEBPACK FOOTER //
// ./src/app/pages/billing/billing-module.js